export default `
clip-path: url('#cog-clip-path');
`
